import * as React from "react";

function DeleteOutline(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props, {
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style),
    className: ['antd-mobile-icon', props.className].filter(Boolean).join(' ')
  }), /*#__PURE__*/React.createElement("g", {
    id: "DeleteOutline-DeleteOutline",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero",
    id: "DeleteOutline-\u5F62\u72B6\u7ED3\u5408"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33,3 C34.6568542,3 36,4.34314575 36,6 L36,9 L42.6,9 C42.8209139,9 43,9.1790861 43,9.4 L43,11.6 C43,11.8209139 42.8209139,12 42.6,12 L41,12 L41,39 C41,42.3137085 38.3137085,45 35,45 L13,45 C9.6862915,45 7,42.3137085 7,39 L7,12 L5.4,12 C5.1790861,12 5,11.8209139 5,11.6 L5,9.4 C5,9.1790861 5.1790861,9 5.4,9 L12,9 L12,6 C12,4.34314575 13.3431458,3 15,3 L33,3 Z M38,12 L10,12 L10,39 C10,40.5976809 11.24892,41.9036609 12.8237272,41.9949073 L13,42 L35,42 C36.5976809,42 37.9036609,40.75108 37.9949073,39.1762728 L38,39 L38,12 Z M19.6,18 C19.8209139,18 20,18.1790861 20,18.4 L20,35.6 C20,35.8209139 19.8209139,36 19.6,36 L17.4,36 C17.1790861,36 17,35.8209139 17,35.6 L17,18.4 C17,18.1790861 17.1790861,18 17.4,18 L19.6,18 Z M31.6,18 C31.8209139,18 32,18.1790861 32,18.4 L32,35.6 C32,35.8209139 31.8209139,36 31.6,36 L29.4,36 C29.1790861,36 29,35.8209139 29,35.6 L29,18.4 C29,18.1790861 29.1790861,18 29.4,18 L31.6,18 Z M33,6 L15,6 L15,9 L33,9 L33,6 Z"
  }))));
}

export default DeleteOutline;